<template>
  <div ref="refTableGroup" class="table-group">
    <div class="group-title">成本核算报告</div>
    <vxe-grid
      :min-height="tableConfig.minHeight"
      :row-config="{ isCurrent: true }"
      :tree-config="{ transform: true, rowField: 'id', parentField: 'parent_id' }"
      :footer-method="tableFooterMethod"
      :columns="tableColumn"
      :data="list"
      :show-footer="!!list.length"
    >
      <!-- slot_default -->
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image v-if="row.list_chan_pin_tu" :list.sync="row.list_chan_pin_tu" disabled />
      </template>
      <template #default_list_gong_cheng_tu="{ row }">
        <e-upload-image :list.sync="row.list_gong_cheng_tu" disabled />
      </template>
      <template #default_list_yuan_wen_jian="{ row }">
        <e-upload-file :list.sync="row.list_yuan_wen_jian" disabled />
      </template>
      <template #default_list_jian_ce_mu_ban="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_mu_ban" disabled />
      </template>
      <template #default_list_jian_ce_bao_gao="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_bao_gao" disabled />
      </template>
      <template #default_jin_du="{ row }">
        <div class="flex">
          <div class="flex flex-y-center" v-for="(item, index) in jin_du_list" :key="index">
            <span v-if="index">-</span>
            <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
            <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
            <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
          </div>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      jin_du_list: ['待执行', '执行中', '已完成'],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 63
        },
        {
          title: '商品图片',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '商品名称',
          field: 'name',
          width: 144,
          align: 'left',
          treeNode: true
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 100
        },
        {
          title: '单位',
          field: 'unit',
          width: 70
        },
        {
          title: '数量',
          field: 'counts',
          width: 70
        },
        {
          title: '单价',
          field: 'goods_price',
          width: 80
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' },
          width: 80
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' },
          width: 80
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' },
          width: 80
        },
        {
          title: '进度',
          field: 'jin_du',
          slots: { default: 'default_jin_du' },
          width: 132
        },
        {
          title: '备注',
          field: 'remark'
        }
      ]
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig)
      return result
    }
  },
  methods: {
    // 表格底部
    tableFooterMethod({ columns, data }) {
      // 重新计算行金额，修复金额合计不是最新结果的问题
      data.forEach((item) => {
        let a = Number(item.goods_price)
        let b = Number(item.counts)
        item.goods_amount = this.$XEUtils.multiply(a, b)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'goods_price', 'goods_amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.table-group {
}
</style>
